import Signal from 'libs/signals';
import api from 'api/api';
import $loader from 'signals/Loader.signal';
import $alert from 'signals/Alert.signal';
import { FundingProgram } from 'types';

export const $fundingPrograms = Signal<{ data: FundingProgram[], mayQualifyFundingPrograms: FundingProgram[]  }>({
  data: [],
  mayQualifyFundingPrograms: [],
});

export const fetchFundingPrograms = async (): Promise<void> => {
  try {
    $loader.update({
      isContentLoading: true,
    });

    const [fundingPrograms, mayQualifyFundingPrograms] = await Promise.all([
      api.get({
        path: '/fundingPrograms',
        options: {},
      }),
      api.get({
        path: '/fundingPrograms/matching',
        options: {},
      }),
    ]);

    $fundingPrograms.update({ data: fundingPrograms, mayQualifyFundingPrograms });
  } catch (error) {
    $alert.update({
      type: 'notification',
      message: error instanceof Error ? error.message : 'An unknown error occurred while fetching funding programs.',
      error,
    });
  } finally {
    $loader.update({
      isContentLoading: false,
    });
  }
}

